import React from 'react';
import { useNavigate } from 'react-router-dom';

const CancelIcon = () => (
    <div className="relative flex items-center justify-center w-20 h-20 mx-auto">
        <div className="absolute inset-0 bg-red-100 dark:bg-red-900/30 rounded-full animate-ping opacity-75" />
        <div className="absolute inset-0 bg-red-100 dark:bg-red-900/30 rounded-full animate-pulse" />
        <div className="relative z-10 flex items-center justify-center w-16 h-16 bg-red-500 rounded-full shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </div>
    </div>
);

export default function PaymentCancel() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 flex flex-col justify-center">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 my-auto">
                <div className="relative bg-white dark:bg-gray-800 shadow-2xl rounded-lg overflow-hidden" style={{ boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 0%, 0 100%, 100% 100%)', margin: '0 -1px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="px-4 py-5 sm:p-6">
                        <div className="text-center">
                            <CancelIcon />
                            <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">
                                تم إلغاء الدفع
                            </h3>
                            <div className="mt-2 space-y-1">
                                <p className="text-sm text-gray-500 dark:text-gray-400">لم يتم تأكيد الطلب.</p>
                                <p className="text-sm text-gray-500 dark:text-gray-400">يمكنك تصفح الدورات واختيار ما يناسبك.</p>
                            </div>
                        </div>

                        <div className="mt-8 flex justify-center space-x-4 space-x-reverse">
                            <button
                                onClick={() => navigate('/courses')}
                                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                تصفح الدورات
                            </button>
                            <button
                                onClick={() => navigate('/')}
                                className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                الرئيسية
                            </button>
                        </div>
                    </div>
                    
                    <div className="w-full h-6 bg-gray-100 dark:bg-gray-900 overflow-hidden">
                        <div className="flex w-full justify-between">
                            {[...Array(40)].map((_, i) => (
                                <div key={i} className="w-3 h-6 bg-white dark:bg-gray-800" style={{ clipPath: 'polygon(50% 100%, 0 0, 100% 0)', margin: '0 -1px', boxShadow: '0 -1px 2px rgba(0,0,0,0.1)' }}></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
